import { render, staticRenderFns } from "./vehicleDetail.vue?vue&type=template&id=07943d73&scoped=true"
import script from "./vehicleDetail.vue?vue&type=script&lang=js"
export * from "./vehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleDetail.vue?vue&type=style&index=0&id=07943d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07943d73",
  null
  
)

export default component.exports